// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton de la carte : silhouettes France + DOM en gris pulsant */
.perimetre-map-skeleton {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.perimetre-map-skeleton-svg {
  width: 100%;
  height: auto;
  max-height: 52rem;
  display: block;
}

.perimetre-map-skeleton-dom {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.perimetre-map-skeleton-dom-svg {
  width: 6rem;
  height: 5.5rem;
}

.perimetre-map-skeleton-path {
  fill: #e9ebed;
  animation: perimetre-skel-pulse 1.2s ease-in-out infinite;
}

@keyframes perimetre-skel-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}
`, "",{"version":3,"sources":["webpack://./src/composants/PerimetreSelector/PerimetreMapSkeleton.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB","sourcesContent":["/* Skeleton de la carte : silhouettes France + DOM en gris pulsant */\n.perimetre-map-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n}\n\n.perimetre-map-skeleton-svg {\n  width: 100%;\n  height: auto;\n  max-height: 52rem;\n  display: block;\n}\n\n.perimetre-map-skeleton-dom {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.perimetre-map-skeleton-dom-svg {\n  width: 6rem;\n  height: 5.5rem;\n}\n\n.perimetre-map-skeleton-path {\n  fill: #e9ebed;\n  animation: perimetre-skel-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes perimetre-skel-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.45; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
